var _rect, _rect2, _rect3, _path, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOccupation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.8043,
    width: 5.69565,
    height: 5.69565,
    rx: 0.5,
    stroke: "#606060",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0654,
    y: 14.8043,
    width: 5.69565,
    height: 5.69565,
    rx: 0.5,
    stroke: "#606060",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0654,
    y: 0.5,
    width: 5.69565,
    height: 5.69565,
    rx: 0.5,
    stroke: "#606060",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34766 14.3044V10.4783H12.9129M22.4781 14.3044V10.4783H12.9129M12.9129 10.4783V5.69568M12.9129 10.4783V14.3044",
    stroke: "#606060",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 14.5,
    width: 5.69565,
    height: 5.69565,
    rx: 0.5,
    stroke: "#606060",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOccupation);
export default __webpack_public_path__ + "static/media/icon-occupation.d6b4fc75d3f578b273f8abb540df32c4.svg";
export { ForwardRef as ReactComponent };